import React from 'react'
import { Link } from 'react-router-dom'
import VideoColumn from './VideoColumn'
import iconTop from '../../../../assets/html/dist/img/shop-ui_icon_movie-management-red.png'

const videos = [
  {
    col1: 'img',
    col2: 'column',
    col3: 'column',
    col4: 'column',
    col5: 'column',
    col6: 'column',
    col7: 'column'
  },
  {
    col1: 'img',
    col2: 'column',
    col3: 'column',
    col4: 'column',
    col5: 'column',
    col6: 'column',
    col7: 'column'
  },
  {
    col1: 'img',
    col2: 'column',
    col3: 'column',
    col4: 'column',
    col5: 'column',
    col6: 'column',
    col7: 'column'
  },
  {
    col1: 'img',
    col2: 'column',
    col3: 'column',
    col4: 'column',
    col5: 'column',
    col6: 'column',
    col7: 'column'
  },
  {
    col1: 'img',
    col2: 'column',
    col3: 'column',
    col4: 'column',
    col5: 'column',
    col6: 'column',
    col7: 'column'
  },
  {
    col1: 'img',
    col2: 'column',
    col3: 'column',
    col4: 'column',
    col5: 'column',
    col6: 'column',
    col7: 'column'
  }
]
const name = 'string'

const VideosList: React.FC<{}> = () => (
  <div className="tab-pane fade show active" id="StoreInformation-BasicInformation" role="tabpanel" aria-labelledby="StoreInformation-BasicInformation-tab">
    <h3 className="mb-4">
      <img src={iconTop} alt="店舗情報" />動画一覧
    </h3>
    <div className="d-flex justify-content-between align-items-center">
      <div className="d-flex tabs-menu">
        <Link to="/" className="active mr-2 pr-2">公開中</Link> | <Link className="ml-2 pl-2" to="/">非公開</Link>
      </div>
      <Link to="/" className="btn btn-outline-red">新規追加</Link>
    </div>
    <div className="table-responsive">
      <table className="table table-borderless">
        <thead>
          <tr>
            <th scope="col">勃画</th>
            <th scope="col">タイトノレ</th>
            <th scope="col">力テゴリ </th>
            <th scope="col">日付 </th>
            <th scope="col">一部視聴回数</th>
            <th scope="col">全部視聴匡数</th>
            <th scope="col">真主三三問（分）</th>
          </tr>
        </thead>
        <tbody>
          {videos.map(video => (<VideoColumn video={video} />))}
        </tbody>
      </table>
    </div>
  </div>
)

export default VideosList
